module.exports = __webpack_public_path__ + "img/symbol_2.c63a7423.png";